import React, { Fragment, useContext } from "react";
import Lottie from "lottie-react";
import LottieFile from "../../assets/lottie/94900-error.json";
import { AppContext } from "../../context/AppContext";

function Errorpage(props) {
  const { setTokenError, setTokenData } = useContext(AppContext);

  const handleTokenData = () => {
    localStorage.clear();
    setTokenError(null);
    // setTokenData(null);
  };
  return (
    <Fragment>
      <div className="error-container">
        <div className="error-content">
          <h1 className="text-center">{props.errorTitle}</h1>
          <div className="err-img">
            <Lottie options={LottieFile} width={250} height={250}></Lottie>
          </div>
          <p className="err-desc">{props.errorMsg}</p>
          <div className="row text-center">
            <div className="col mx-auto">
              <button className="review-err" onClick={handleTokenData}>
                Retry
              </button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default Errorpage;
